import { endpoints, baseurl } from "../Utils/Constants";

const authHeaders = (token) => ({
  "ngrok-skip-browser-warning": "true",
  "Authorization": `Bearer ${token}`,
});

// GET /api/dashboard/tabs -> [{ id, label }] already RBAC-filtered server-side.
export const getDashboardTabs = async (token) => {
  try {
    const response = await fetch(baseurl + endpoints.DASHBOARD_TABS, {
      method: "GET",
      cache: "no-store",
      headers: authHeaders(token),
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching dashboard tabs:", error);
    throw error;
  }
};

// GET /api/dashboard/organisations -> [{ id, name }] (superadmin only).
export const getDashboardOrganisations = async (token) => {
  try {
    const response = await fetch(baseurl + endpoints.DASHBOARD_ORGANISATIONS, {
      method: "GET",
      cache: "no-store",
      headers: authHeaders(token),
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching dashboard organisations:", error);
    throw error;
  }
};

// GET /api/dashboard/{superadmin|admin}/{tab}?account_id=&ai_type=
//   -> { kpis: { id: value }, charts: { id: { labels, datasets } } }
//   Static copy (titles, descriptions, formulas, chart types) lives in
//   Utils/metricsConfig.js; dashboardChartAdapter.buildDashboard() merges them.
export const getDashboardAnalytics = async (
  token,
  { tab, isSuperAdmin = false, accountId = null, aiType = null, modules = null, aiEngines = null, signal } = {}
) => {
  try {
    const base = isSuperAdmin ? endpoints.DASHBOARD_SUPERADMIN : endpoints.DASHBOARD_ADMIN;
    const params = new URLSearchParams();
    if (isSuperAdmin && accountId) params.set("account_id", accountId);
    if (aiType) params.set("ai_type", aiType);
    if (Array.isArray(modules)) params.set("modules", modules.join(","));
    if (Array.isArray(aiEngines)) params.set("ai_engines", aiEngines.join(","));
    const query = params.toString();
    const url = `${baseurl}${base}${encodeURIComponent(tab)}${query ? `?${query}` : ""}`;
    const response = await fetch(url, {
      method: "GET",
      cache: "no-store",
      headers: authHeaders(token),
      signal,
    });
    return await response.json();
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    console.error("Error fetching dashboard analytics:", error);
    throw error;
  }
};
